// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"28f547fe","239":"e8eefa59","455":"912c08d7","977":"7b5018d0"}[chunkId] + ".chunk.js";
};